import { useModalMeta } from "@/shared/atoms/useModal";
import useKeyPress from "@/shared/hooks/useKeyPress";
import usePrint from "@/shared/hooks/usePrint";
import useOrderSessionReceiptQuery from "@/shared/queries/orderssessions/useOrderSessionReceiptQuery";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import Modal, { ModalProps } from "../Modal/Modal";
import ModalTitle from "../Modal/ModalTitle";

const PrintSessionReceipt = ({ onExit, ...props }: ModalProps) => {
  const printSessionReceipt = useOrderSessionReceiptQuery();
  const [meta] = useModalMeta();
  const { sessionId, customLabel } = meta;

  const { t } = useTranslation("");
  const enter = useKeyPress("Enter");

  useEffect(() => {
    enter && handlePrint();
  }, [enter]);
  const print = usePrint();

  const handlePrint = (isCustomerReceipt?: number) => {
    printSessionReceipt
      .mutateAsync({ sessionId, isCustomerReceipt })
      .then((data) => {
        print(data);
        onExit();
      });
  };

  return (
    <Modal width="50rem" onExit={onExit} {...props}>
      <ModalTitle>{t("posOrders.printOrder")}</ModalTitle>
      {customLabel && <p>{customLabel}</p>}
      <div className="mt-12 flex justify-end gap-4">
        <Button variant="secondary" type="button" onClick={() => onExit()}>
          {t("close")}
        </Button>
        <Button onClick={() => handlePrint(1)}>{t("clientReceipt")}</Button>
        <Button onClick={() => handlePrint(0)}>{t("Print")}</Button>
      </div>
    </Modal>
  );
};

export default PrintSessionReceipt;
